export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-torsos-all-female-96b19d92cd2d8c5774747d2c2ef27862.svg";